import { Button } from '@design/components/button/Button';
import React from 'react';
import { useTranslation } from 'react-i18next';

import sharedStyles from '../Shared.module.scss';

export const ScenarioUsageExceeded = ({
  assetsCount,
  conditionsCount,
}: {
  assetsCount: number;
  conditionsCount: number;
}) => {
  const { t } = useTranslation('scenario');
  const scenarioPageTitle = `${t('scenario:emptyState.assetsAnd', {
    count: assetsCount,
  })} ${t('scenario:emptyState.conditionsSelected', {
    count: conditionsCount,
  })}`;

  return (
    <div className={sharedStyles.container}>
      <img
        className={sharedStyles.img}
        src="/app/static/images/icons/no-assets-found.svg"
        alt=""
      />
      <div className={sharedStyles.description}>
        <p className={sharedStyles.title}>{scenarioPageTitle}</p>
        <Button
          className={sharedStyles.styledButton}
          variant="primary"
          label={t('scenario:buttonLabels.runScenario')}
          disabled
        />
      </div>
    </div>
  );
};
